import { featureFlags } from 'client/utils/feature-flags';

export const INSIDER_NAVIGATION_TAB_NAMES = {
  INVENTORY: 'inventory',
  SEARCH: 'search',
  APPRAISAL: 'appraisal',
  LISTING: 'listing',
  MODELS: 'favorite-models',
  GARAGE: 'gear-garage',
  SETTINGS: 'settings',
};

export const INSIDER_NAVIGATION_MAP = {
  [INSIDER_NAVIGATION_TAB_NAMES.INVENTORY]: {
    tabName: 'Saved Inventory',
  },
  [INSIDER_NAVIGATION_TAB_NAMES.SEARCH]: {
    tabName: 'Saved Searches',
  },
  [INSIDER_NAVIGATION_TAB_NAMES.APPRAISAL]: {
    tabName: 'My Cars for Sale',
  },
  [INSIDER_NAVIGATION_TAB_NAMES.MODELS]: {
    tabName: 'Favorite Models',
  },
  [INSIDER_NAVIGATION_TAB_NAMES.GARAGE]: {
    tabName: 'Gear Garage',
  },
  [INSIDER_NAVIGATION_TAB_NAMES.SETTINGS]: {
    tabName: 'Account',
  },
};

export function navigationFilter(key) {
  const { gearGarage = false } = featureFlags.get();
  return key !== INSIDER_NAVIGATION_TAB_NAMES.GARAGE || gearGarage;
}
